<template>
  <div>
    <drag
      class="companies"
      :options="dragCompaniesOptions"
      :list="companies"
      :disabled="!isWriteAvailable"
    >
      <v-card
        v-for="(company, i) in companies"
        :key="`${company.name}-${i}`"
        class="company"
      >
        <v-card-title class="company__header primary">
          <h3>{{ i + 1 }}. {{ company.name }}</h3>
        </v-card-title>
        <v-divider v-if="company.participants"></v-divider>
        <v-card-text v-if="company.participants" class="company__body">
          <h5>Participants:</h5>
          <drag
            :options="dragParticipantsOptions"
            :list="company.participants"
          >
            <v-card
              v-for="(participant, j) in company.participants"
              :key="`participant-${j}`"
              class="company__participant"
            >
              <div
                v-for="(field, k) in Object.keys(participant)"
                :key="`participant-field-${k}`"
              >
                <span v-if="field !== 'order'">
                  <i>{{ field }}:</i> <span v-html="participant[field]"></span>
                </span>
              </div>
            </v-card>
          </drag>
        </v-card-text>
      </v-card>
    </drag>
    <v-btn color="success" @click="saveChanges" :disabled="!isWriteAvailable">Save</v-btn>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { sortWith, ascend, prop, compose, map, path } from 'ramda'
  import mixins from '@/utils/mixins'

  export default {
    name: 'DisplaySettings',
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        companies: [],
        dragCompaniesOptions: {
          ghostClass: 'company_ghost'
        },
        dragParticipantsOptions: {
          ghostClass: 'participant_ghost'
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'blitz:write'
      }
    },
    computed: {
      ...mapGetters([
        'getCompanies'
      ])
    },
    watch: {
      getCompanies (companies) {
        this.setCompatiesList(companies)
      }
    },
    methods: {
      ...mapActions([
        'fetchCompaniesList',
        'updateCompanies'
      ]),
      setCompatiesList (companies) {

        // sort by order, if order equals sort by name
        const sortCompanies = sortWith([
          ascend(prop('order')),
          ascend(prop('name'))
        ])

        // just sort by order
        const sortParticipants = sortWith([
          ascend(prop('order'))
        ])

        // generate company object with necessary props
        const transformCompany = company => ({
          id: company.id,
          name: company.blitzInvitation.company || company.metadata.companyName,
          order: company.blitzCard.order,
          participants: path(['metadata', 'participants', 'length'], company)
            ? sortParticipants(company.metadata.participants)
            : null
        })

        const generateSortedCompaniesList = compose(sortCompanies, map(transformCompany))

        this.companies = generateSortedCompaniesList(companies)
      },
      saveChanges () {
        // save new order of companies and participants
        this.companies.map((company, i) => {
          company.order = i
          if (path(['participants', 'length'], company)) {
            company.participants.map((participant, j) => {
              participant.order = j
            })
          }
        })

        // send updated companies on BE
        this.updateCompanies(this.companies)
      }
    },
    async created () {
     await this.fetchCompaniesList({fetchAll: true})
     this.setCompatiesList(this.getCompanies)
    }
  }
</script>

<style lang="scss" scoped>
  .companies {
    min-height: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    @media (max-width: 1000px) {
      justify-content: space-between;
    }
  }

  .company {
    width: 23%;
    margin: 10px;
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    box-sizing: border-box;

    &__header {
      color: white;
    }

    &__participant {
      max-width: 400px;
      overflow: auto;
      padding: 5px;
      margin-top: 10px;
    }

    &__body {
      background: #e8eaf6;
    }

    &_ghost {
      opacity: 0.35;
      background: lightgray;
    }

    @media (max-width: 1000px) {
      width: 45%;
    }

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .participant {
    &_ghost {
      opacity: 0.35;
      background: lightgray;
    }
  }

  .submit-btn-wrapper {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Blitz/display-settings/index.vue